import app from './app'

import reports from './reports'
import tracking from './tracking'
import wasl from './wasl'
import plans from '@/navigation/vertical/plans'
import gplans from '@/navigation/vertical/gplans'
import fieldServices from '@/navigation/vertical/fieldServices'

// Array of sections
export default [
  ...app,
  ...plans,
  ...gplans,
  ...reports,
  ...fieldServices,
  ...tracking,
]
